module.exports = __webpack_public_path__ + "static/media/xebia_logo.52fd0229.png";